import { isAfter, parseISO } from 'date-fns';
import { useMemo } from 'react';

import type { INDBFlow } from '@/helpers/NDBFlow';
import { groupMemberNotConfirmedNDB } from '@/helpers/user';
import { STORAGE, useGetCommonStore, useLocalStorageStore } from '@/store';
import { useIsNoDepositUser } from './useIsNoDepositUser';

const RELEASE_NDB_FLOW_DATE = parseISO('2025-08-07T00:00:00Z');

export const useNDBFlow = () => {
  const useCommonStore = useGetCommonStore();

  const user = useCommonStore.use.user();
  const localNDBFlow = useLocalStorageStore
    .getState()
    .get<INDBFlow | null>(STORAGE.NDB_FLOW);

  const { isNoDepositUser } = useIsNoDepositUser();

  const { isNDBFlow, isAfterReleaseDate } = useMemo(() => {
    const isNotConfirmedNDBUser = groupMemberNotConfirmedNDB(user);
    const isAfterReleaseDate =
      !!user?.confirmedAt &&
      isAfter(
        parseISO(user.confirmedAt.replace(' UTC', 'Z')),
        RELEASE_NDB_FLOW_DATE
      );

    const isNDBFlow =
      !!localNDBFlow?.isNDBFlow || (isNotConfirmedNDBUser && isNoDepositUser);

    return {
      isNDBFlow,
      isAfterReleaseDate,
    };
  }, [user, isNoDepositUser, localNDBFlow?.isNDBFlow]);

  return {
    isNDBFlow,
    localNDBFlow,
    isAfterReleaseDate,
    isNoDepositUser,
  };
};
